<template>
    <div>
        <van-nav-bar
                title="加工查询"
                left-text=""
                right-text="筛选"
                left-arrow
                fixed
                @click-left="back()"
                @click-right="searchPop()"
                v-if="show"
        />
        <!--    <van-sticky :offset-top="45">-->
        <!--      <div class="hejcss">-->
        <!--        合计：任务{{ notifyCount }}笔，作业{{ taskCount }}笔，重量-->
        <!--        {{-->
        <!--          sumWeight == '&#45;&#45;' ? '&#45;&#45;' : isNaN((sumWeight / 1000).toFixed(3))?0:(sumWeight / 1000).toFixed(3)-->
        <!--        }}吨-->
        <!--      </div>-->
        <!--    </van-sticky>-->
        <div class="contentwarp">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <van-cell v-for="item in list" :key="item.processtaskId" class="swipewarp"
                              @click="showDetail(true, item)">
                        <van-row gutter="20">
                            <van-col span="15" class="ellipsis">
                                加工单号：{{ item.processtaskNo }}
                            </van-col>
                            <van-col span="9" class="ellipsisRight">
                                状态：{{ item.processtaskStatus | formatProcesstaskStatus}}
                            </van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="10" class="ellipsis">
                                客户单号：{{ item.processnotifyCustomerNo }}
                            </van-col>
                            <van-col span="14" class="ellipsisRight">
                                工序：{{ item.processName }}
                            </van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="8" class="ellipsis">
                                开单时间：
                            </van-col>
                            <van-col span="16" class="ellipsisRight">
                                {{ item.auditTime | moment("YYYY-MM-DD HH:mm:ss")}}
                            </van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="8" class="ellipsis">
                                完成时间：
                            </van-col>
                            <van-col span="16" class="ellipsisRight">
                                {{ item.completeTime | moment("YYYY-MM-DD HH:mm:ss") }}
                            </van-col>
                        </van-row>
                    </van-cell>
                </van-list>
            </van-pull-refresh>
        </div>

        <van-popup v-model="searchShowPop" position="right" :style="{ height: '100%', width:'90%'}">
            <van-nav-bar
                    title="筛选"
                    fixed
                    z-index="9000"
                    left-arrow
                    @click-left="() => this.searchShowPop = false"
            />
            <div class="searchwarp">
                <van-field v-model="searchValue.processtaskNo" label="单号查询" placeholder="加工单号/客户单号" autocomplete="off"
                           label-width="80px" label-align="right"/>
                <van-field v-model="searchValue.defaultDate" label="开单日期" readonly="readonly" placeholder="点击选择日期"
                           autocomplete="off"
                           @click="calendarShow=true" label-width="80px" label-align="right"/>
                <van-field :value="status" readonly name="picker" label="状态" placeholder="点击选择状态"
                           @click="showPicker('showPickerSta')"
                           label-width="80px" label-align="right"/>
                <van-calendar v-model="calendarShow"
                              :min-date=" new Date(2020, 9, 1)"
                              :default-date="[new Date((new Date()-30000*60*60*24)),new Date() ]"
                              type="range" @confirm="calendarConfirm"/>
                <van-picker
                        title="状态"
                        v-if="showPickerSta"
                        show-toolbar
                        :columns="statusCol"
                        @confirm="selStatusVal"
                        @cancel="showPickerSta = false"
                />
                <van-row gutter="20" style="margin-top:20px">
                    <van-col span="8" offset="4">
                        <van-button block size="small" type="info" native-type="submit" class="button"
                                    @click="resetSearch()">
                            重置
                        </van-button>
                    </van-col>
                    <van-col span="8">
                        <van-button block size="small" type="info" native-type="submit" class="button"
                                    @click="onSearch()">
                            确定
                        </van-button>
                    </van-col>
                </van-row>
            </div>
        </van-popup>

        <van-popup v-model="detailPop" :style="{ height: '100%', width:'100%',overflow: 'hidden'}">
            <van-nav-bar
                    title="工序明细"
                    left-arrow
                    @click-left="showDetail(false)"
            />
            <div style="height:calc(100vh - 50px); overflow: auto;">
            <div class="van-doc-demo-block">
                <van-row>
                    <van-col span="10"><h2 class="van-doc-demo-block__title">{{ processtaskNo }}</h2></van-col>
                    <van-col span="14"><h2 class="van-doc-demo-block__title" style="text-align: right">
                        {{ processtaskStatus | formatProcesstaskStatus }}
                    </h2></van-col>
                </van-row>
                <div class="van-cell-group van-hairline--bottom">
                    <div class="van-cell">
                        <div class="van-cell__title"><span>开单时间</span></div>
                        <div class="van-cell__value"><span>{{ auditTime | moment("YYYY-MM-DD HH:mm:ss")}}</span></div>
                    </div>
                    <div class="van-cell">
                        <div class="van-cell__title"><span>客户单号</span></div>
                        <div class="van-cell__value"><span>{{ processnotifyCustomerNo }}</span></div>
                    </div>
                    <div class="van-cell">
                        <div class="van-cell__title"><span>工序名称</span></div>
                        <div class="van-cell__value"><span>{{ processName }}</span></div>
                    </div>
                    <div class="van-cell">
                        <div class="van-cell__title"><span>加工机台</span></div>
                        <div class="van-cell__value"><span>{{ machineName }} / {{ machineDetailName }}</span></div>
                    </div>
                    <div class="van-cell">
                        <div class="van-cell__title"><span>开始时间</span></div>
                        <div class="van-cell__value"><span>{{ startTime | moment("YYYY-MM-DD HH:mm:ss")}}</span></div>
                    </div>
                    <div class="van-cell">
                        <div class="van-cell__title"><span>完成时间</span></div>
                        <div class="van-cell__value"><span>{{ completeTime | moment("YYYY-MM-DD HH:mm:ss")}}</span></div>
                    </div>
                </div>
            </div>

<!--            <van-cell>-->
<!--                <van-row gutter="20">-->
<!--                    <van-col span="10" class="ellipsis" style="font-weight: bold;font-size: 16px">-->
<!--                        {{ processtaskNo }}-->
<!--                    </van-col>-->
<!--                    <van-col span="14" class="ellipsisRight" style="font-weight: bold;font-size: 16px">-->
<!--                        {{ processtaskStatus | formatProcesstaskStatus }}-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--                <van-row gutter="20" style="color: #727272">-->
<!--                    <van-col span="10" class="ellipsis">-->
<!--                        开单时间-->
<!--                    </van-col>-->
<!--                    <van-col span="14"-->
<!--                             style="text-align: right; overflow: hidden; white-space:nowrap; text-overflow: ellipsis;">-->
<!--                        {{ auditTime | moment("YYYY-MM-DD HH:mm:ss")}}-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--                <van-row gutter="20" style="color: #727272">-->
<!--                    <van-col span="10" class="ellipsis">-->
<!--                        客户单号-->
<!--                    </van-col>-->
<!--                    <van-col span="14" class="ellipsisRight">-->
<!--                        {{ processnotifyCustomerNo }}-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--                <van-row gutter="20" style="color: #727272">-->
<!--                    <van-col span="10" class="ellipsis">-->
<!--                        工序名称-->
<!--                    </van-col>-->
<!--                    <van-col span="14" class="ellipsisRight">-->
<!--                        {{ processName }}-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--                <van-row gutter="20" style="color: #727272">-->
<!--                    <van-col span="10" class="ellipsis">-->
<!--                        加工机台-->
<!--                    </van-col>-->
<!--                    <van-col span="14" class="ellipsisRight">-->
<!--                        {{ machineName }} / {{ machineDetailName }}-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--                <van-row gutter="20" style="color: #727272">-->
<!--                    <van-col span="10" class="ellipsis">-->
<!--                        开始时间-->
<!--                    </van-col>-->
<!--                    <van-col span="14" class="ellipsisRight">-->
<!--                        {{ startTime | moment("YYYY-MM-DD HH:mm:ss")}}-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--                <van-row gutter="20" style="color: #727272">-->
<!--                    <van-col span="10" class="ellipsis">-->
<!--                        完成时间-->
<!--                    </van-col>-->
<!--                    <van-col span="14" class="ellipsisRight">-->
<!--                        {{ completeTime | moment("YYYY-MM-DD HH:mm:ss")}}-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--            </van-cell>-->
            <van-row>
                <van-col span="6"><h2 class="van-doc-demo-block__title">原料明细</h2></van-col>
                <van-col span="18"><h2 class="van-doc-demo-block__title" style="text-align: right;font-weight: bold;color: #333">
                    合计：{{proTotalCount}}件，重量{{ (proTotalWeight / 1000).toFixed(3) }}吨
                </h2></van-col>
            </van-row>
<!--            <van-cell style="padding-bottom: 0">-->
<!--                <van-row gutter="20">-->
<!--                    <van-col span="6"-->
<!--                             style=" overflow: hidden;white-space:nowrap;text-overflow: ellipsis;font-weight: bold;font-size: 16px">-->
<!--                        原料明细-->
<!--                    </van-col>-->
<!--                    <van-col span="18" class="ellipsisRight">-->
<!--                        合计：{{proTotalCount}}件，重量{{ (proTotalWeight / 1000).toFixed(3) }}吨-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--            </van-cell>-->
            <div class="van-cell-group van-hairline--bottom" v-for="item in rawMaterialList" :key="item.processnotifyDetailId">
                <div class="van-cell">
                    <div class="van-cell__title"><span>物料号/钢卷号</span></div>
                    <div class="van-cell__value"><span>{{ item.cargoNumber }}/{{ item.tscNumber }}</span></div>
                </div>
                <div class="van-cell">
                    <div class="van-cell__title" style="width: 50px"><span>品名</span></div>
                    <div class="van-cell__value"><span>
                             {{ item.cargoProcessName }}/{{ item.cargoMaterialName }}/{{item.cargoThickness}}/{{ item.cargoOriginName }}/{{ item.surfaceName }}
                        </span></div>
                </div>
                <div class="van-cell">
                    <div class="van-cell__title"><span>件数/重量</span></div>
                    <div class="van-cell__value"><span>{{ item.amount }}件/{{ item.weight }}公斤</span></div>
                </div>

            </div>
<!--            <van-cell v-for="item in rawMaterialList" :key="item.processnotifyDetailId">-->
<!--                <van-row gutter="20" style="color: #727272">-->
<!--                    <van-col span="10" class="ellipsis">-->
<!--                        物料号/钢卷号-->
<!--                    </van-col>-->
<!--                    <van-col span="14" class="ellipsisRight">-->
<!--                        {{ item.cargoNumber }}/{{ item.tscNumber }}-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--                <van-row gutter="20" style="color: #727272">-->
<!--                    <van-col span="3" class="ellipsis">-->
<!--                        品名-->
<!--                    </van-col>-->
<!--                    <van-col span="21" class="ellipsisRight">-->
<!--                        {{ item.cargoProcessName }}/{{ item.cargoMaterialName }}/{{item.cargoThickness}}/{{ item.cargoOriginName }}/{{ item.surfaceName }}-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--                <van-row gutter="20" style="color: #727272">-->
<!--                    <van-col span="10" class="ellipsis">-->
<!--                        件数/重量-->
<!--                    </van-col>-->
<!--                    <van-col span="14" class="ellipsisRight">-->
<!--                        {{ item.amount }}件/{{ item.weight }}公斤-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--            </van-cell>-->
            <van-list
                    style="padding-top: 0"
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
            >
            <van-row>
                <van-col span="6"><h2 class="van-doc-demo-block__title">成品明细</h2></van-col>
                <van-col span="18"><h2 class="van-doc-demo-block__title" style="text-align: right;font-weight: bold;color: #333">
                    合计：{{pacCount}}包，{{pacTotalCount}}件，重量{{ (pacTotalWeight / 1000).toFixed(3) }}吨
                </h2></van-col>
            </van-row>
<!--            <van-cell style="padding-bottom: 0">-->
<!--                <van-row gutter="20">-->
<!--                    <van-col span="6"-->
<!--                             style=" overflow: hidden;white-space:nowrap;text-overflow: ellipsis;font-weight: bold;font-size: 16px">-->
<!--                        成品明细-->
<!--                    </van-col>-->
<!--                    <van-col span="18" class="ellipsisRight">-->
<!--                        合计：{{pacCount}}包，{{pacTotalCount}}件，重量{{ (pacTotalWeight / 1000).toFixed(3) }}吨-->
<!--                    </van-col>-->
<!--                </van-row>-->
<!--            </van-cell>-->
            <div v-for="item in productList" :key="item.processtaskProductId">
                <div :style="item.showView">
                <van-row gutter="20" v-if="item.isShowMerge" style="background: #fee7c5;padding: 5px 16px;font-size: 14px">
                    <van-col span="24" v-if="item.isShowMerge" class="ellipsis">
                        包装号:{{ item.packageNo }}({{ item.packageName }})
                    </van-col>

                </van-row>
                <div class="van-cell-group van-hairline--top-bottom">
                    <div class="van-cell">
                        <div class="van-cell__title"><span>物料号/钢卷号</span></div>
                        <div class="van-cell__value"><span>{{ item.cargoNumber }}/{{ item.tscNumber }}</span></div>
                    </div>
                    <div class="van-cell">
                        <div class="van-cell__title" style="width: 50px"><span>品名</span></div>
                        <div class="van-cell__value"><span>
                           {{ item.cargoProcessName }}/{{ item.cargoMaterialName }}/{{
                            item.cargoThickness == null ? '' : item.cargoThickness
                            }}x{{ item.cargoWidth == null ? '' : item.cargoWidth }}x{{ item.cargoLength | getCargoLength
                            }}/{{ item.cargoOriginName }}/{{ item.surfaceName }}
                        </span></div>
                    </div>
                    <div class="van-cell">
                        <div class="van-cell__title"><span>件数/重量</span></div>
                        <div class="van-cell__value"><span>{{ item.amount }}件/{{ item.weight }}公斤</span></div>
                    </div>
                </div>
                </div>
            </div>
            </van-list>
            <!-- <div v-for="item in productList" :key="item.processtaskProductId" style="padding: 0">
                 <div :style="item.showView">
                     <van-row gutter="20" v-if="item.isShowMerge" style="background: #f7f8fa;">
                         <van-col span="24" v-if="item.isShowMerge">
                             包装号:{{ item.packageNo }}({{ item.packageName }})
                         </van-col>
                     </van-row>
                     <van-row gutter="20" style="color: #727272">
                         <van-col span="10" class="ellipsis">
                             物料号/钢卷号
                         </van-col>
                         <van-col span="14" class="ellipsisRight">
                             {{ item.cargoNumber }}/{{ item.tscNumber }}
                         </van-col>
                     </van-row>
                     <van-row gutter="20" style="color: #727272">
                         <van-col span="3" class="ellipsis">
                             品名
                         </van-col>
                         <van-col span="21" class="ellipsisRight">
                             {{ item.cargoProcessName }}/{{ item.cargoMaterialName }}/{{
                             item.cargoThickness == null ? '' : item.cargoThickness
                             }}x{{ item.cargoWidth == null ? '' : item.cargoWidth }}x{{ item.cargoLength | getCargoLength
                             }}/{{ item.cargoOriginName }}/{{ item.surfaceName }}
                         </van-col>
                     </van-row>
                     <van-row gutter="20" style="color: #727272">
                         <van-col span="10" class="ellipsis">
                             件数/重量
                         </van-col>
                         <van-col span="14" class="ellipsisRight">
                             {{ item.amount }}件/{{ item.weight }}公斤
                         </van-col>
                     </van-row>
                 </div>-->
                 <!--<van-cell  v-if="!item.isShowView" style="padding-top: 0;padding-bottom: 0">
                     <van-row gutter="20" v-if="item.isShowMerge" style="background: #f7f8fa;">
                         <van-col span="24" v-if="item.isShowMerge"
                                  style="text-align: left;word-break:keep-all;white-space:nowrap;font-weight: bold">
                             包装号:{{ item.packageNo }}({{ item.packageName }})
                         </van-col>
                     </van-row>
                     <van-row gutter="20" style="color: #727272">
                         <van-col span="10" class="ellipsis">
                             物料号/钢卷号
                         </van-col>
                         <van-col span="14" class="ellipsisRight">
                             {{ item.cargoNumber }}/{{ item.tscNumber }}
                         </van-col>
                     </van-row>
                     <van-row gutter="20" style="color: #727272">
                         <van-col span="3" class="ellipsis">
                             品名
                         </van-col>
                         <van-col span="21" class="ellipsisRight">
                             {{ item.cargoProcessName }}/{{ item.cargoMaterialName }}/{{
                             item.cargoThickness == null ? '' : item.cargoThickness
                             }}x{{ item.cargoWidth == null ? '' : item.cargoWidth }}x{{ item.cargoLength | getCargoLength
                             }}/{{ item.cargoOriginName }}/{{ item.surfaceName }}
                         </van-col>
                     </van-row>
                     <van-row gutter="20" style="color: #727272">
                         <van-col span="10" class="ellipsis">
                             件数/重量
                         </van-col>
                         <van-col span="14" class="ellipsisRight">
                             {{ item.amount }}件/{{ item.weight }}公斤
                         </van-col>
                     </van-row>
                 </van-cell>-->
            <!--</div>-->
            </div>
        </van-popup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {
        Button,
        Calendar,
        Cell,
        Col,
        Divider,
        Field,
        Form,
        Grid,
        GridItem,
        Icon,
        Image as VanImage,
        ImagePreview,
        Lazyload,
        List,
        NavBar,
        Picker,
        Popup,
        PullRefresh,
        Radio,
        RadioGroup,
        Row,
        Search,
        Sticky,
        SwipeCell,
        Toast
    } from 'vant';
    import service from '../../server/index'

    Vue.use(Lazyload, {
        lazyComponent: true,
    });

    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Divider.name]: Divider,
            [VanImage.name]: VanImage,
            [ImagePreview.Component.name]: ImagePreview.Component,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Form.name]: Form,
            [Picker.name]: Picker
        },
        computed: {},
        data() {
            return {
                show: true,//nav bar
                list: [],
                loading: true,
                finished: false,
                searchValue: {},
                showPickerNotifySta: false,
                selProcessNotifyStatus: '',
                selProcessName: '',
                showPickerPro: false,
                selMachineName: '',
                showPickerMac: false,
                selMachineDetailName: '',
                showPickerMacD: false,
                selProcesstaskStatus: '',
                showPickerProSta: false,
                notifyStatusCol: ['新建', '审核', '发料', '完结'],
                notifyStatusData: [
                    {value: '10'},
                    {value: '20'},
                    {value: '30'},
                    {value: '100'},
                ],
                processTaskStatusCol: ['新建', '待加工', '加工中', '已完成', '已验收'],
                processTaskStatusData: [
                    {value: '10'},
                    {value: '20'},
                    {value: '30'},
                    {value: '40'},
                    {value: '50'},
                ],
                processData: [],
                processCol: [],
                machineData: [],
                machineCol: [],
                machineDetailData: [],
                machineDetailCol: [],
                searchShowPop: false,
                dateFormat: 'YYYY-MM-DD',
                //刷新
                isLoading: false,
                page: 1,
                pageSize: 20,
                //日期选择calendarShow
                calendarShow: false,
                taskCount: 0,
                sumWeight: 0,
                notifyCount: 0,
                //详情pop
                detailPop: false,
                detailList: [],
                packageDetailPop: false,
                productDetailPop: false,
                packageList: [],
                packageNo: [],
                status: '',
                showPickerSta: false,
                statusCol: ['待加工', '加工中', '已完成', '已验收'],
                statusData: [
                    {value: '20'},
                    {value: '30'},
                    {value: '40'},
                    {value: '50'},
                ],
                processtaskNo: '',
                processtaskStatus: '',
                auditTime: '',
                processnotifyCustomerNo: '',
                processName: '',
                machineName: '',
                machineDetailName: '',
                startTime: '',
                completeTime: '',
                proTotalCount: 0,
                proTotalWeight: 0,
                pacCount: 0,
                pacTotalCount: 0,
                pacTotalWeight: 0,
                rawMaterialList: [],
                productList: [],
            }
        },
        mounted() {
            this.onLoad();
            let parm = {};
            parm.ouid = localStorage.getItem("ouid")
            service.selProcessG(parm).then(res => {
                let data = res.data;
                this.processData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.processCol.push(data[i].processName)
                }
            })
            service.selMachineNameG(parm).then(res => {
                let data = res.data;
                this.machineData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.machineCol.push(data[i].machineName)
                }
            })
        },
        filters: {
            getCargoLength(cargoLength) {
                if (cargoLength == null) {
                    return 'C';
                } else {
                    if (cargoLength == 0) {
                        return 'C';
                    } else {
                        if (cargoLength > 10000) {
                            return cargoLength / 1000 + 'm'
                        } else {
                            return cargoLength
                        }
                    }
                }
            },
            getPosition(item) {
                let {
                    wcode,
                    acode,
                    pcode,
                } = item

                if (wcode != null && acode != null && pcode != null) {
                    return wcode + "/" + acode + "/" + pcode;
                } else if (wcode != null && acode != null) {
                    return wcode + "/" + acode;
                } else if (wcode != null) {
                    return wcode;
                } else {
                    return '';
                }
            },
            formatProcesstaskMode(text) {
                if (text == 20) {
                    return '委外加工'
                } else if (text == 10) {
                    return '自加工'
                } else {
                    return ''
                }
            },
            formatProcesstaskStatus(text) {
                if (text == 10) {
                    return '新建'
                } else if (text == 20) {
                    return '待加工'
                } else if (text == 30) {
                    return '加工中'
                } else if (text == 40) {
                    return '已完成'
                } else if (text == 50) {
                    return '已验收'
                } else {
                    return ''
                }
            }
        },
        methods: {
            showPicker(pickerName) {
                this.calendarShow = false
                this.showPickerSta = false
                this.showPickerCar = false
                this.showPickerMode = false
                this.showPickerMat = false
                this.showPickerOri = false
                this.showPickerSur = false

                switch (pickerName) {
                    case 'calendarShow':
                        this.calendarShow = true
                        break
                    case 'showPickerSta':
                        this.showPickerSta = true
                        break
                    case 'showPickerCar':
                        this.showPickerCar = true
                        break
                    case 'showPickerMode':
                        this.showPickerMode = true
                        break
                    case 'showPickerMat':
                        this.showPickerMat = true
                        break
                    case 'showPickerOri':
                        this.showPickerOri = true
                        break
                    case 'showPickerSur':
                        this.showPickerSur = true
                        break
                    default:
                        return false
                }
            },
            selStatusVal(value, index) {
                this.status = value;
                this.searchValue.status = this.statusData[index].value
                this.showPickerSta = false;
            },
            showMachineDetail() {
                if (this.machineDetailData.length == 0) {
                    Toast('请先选择机组')
                } else {
                    this.showPickerMacD = true
                }
            },
            back() {
                this.$router.replace("/Home/Search")
            },
            selNotifyStatusVal(value, index) {
                this.selProcessNotifyStatus = value;
                this.searchValue.processNotifyStatus = this.notifyStatusData[index].value
                this.showPickerNotifySta = false;
            },
            selProcessTaskStatusVal(value, index) {
                this.selProcesstaskStatus = value;
                this.searchValue.processtaskStatus = this.processTaskStatusData[index].value
                this.showPickerProSta = false;
            },
            selProcessNameVal(value, index) {
                this.selProcessName = value;
                this.searchValue.processId = this.processData[index].processId
                this.showPickerPro = false;
            },
            selMachineVal(value, index) {
                let _this = this;
                this.selMachineName = value;
                this.searchValue.machineId = this.machineData[index].machineId
                _this.machineDetailData = []
                _this.machineDetailCol = []
                _this.selMachineDetailName = ''
                _this.searchValue.machineDetailId = undefined
                service.selMachineDetailNameG({machineId: this.machineData[index].machineId}).then(res => {
                    let data = res.data;
                    _this.machineDetailData = res.data;
                    for (let i = 0; i < data.length; i++) {
                        _this.machineDetailCol.push(data[i].machineDetailName)
                    }
                    _this.showPickerMac = false;
                })
            },
            selMachineDetailVal(value, index) {
                if (this.machineDetailData.length == 0) {
                    Toast('请先选择机组')
                } else {
                    this.selMachineDetailName = value;
                    this.searchValue.machineDetailId = this.machineDetailData[index].machineDetailId
                    this.showPickerMacD = false;
                }
            },
            onSearch() {
                this.list = [];
                this.page = 1;
                this.show = true;
                this.searchShowPop = false;
                this.onLoad();
            },
            onLoad() {
                this.getDetailList();
                // this.getTotalCount();
            },
            getDetailList() {
                let createTimeStart = "";
                let createTimeEnd = "";
                let dateStr = this.searchValue
                if (dateStr != null && dateStr != "" && this.searchValue.startDate != "" && this.searchValue.endDate != "") {
                    createTimeStart = this.searchValue.startDate;
                    createTimeEnd = this.searchValue.endDate
                }

                let searchObj = this.searchValue
                searchObj.startDate = createTimeStart
                searchObj.endDate = createTimeEnd
                searchObj.page = this.page;
                searchObj.size = this.pageSize;
                searchObj.ouid = localStorage.getItem("ouid")
                searchObj.customerId = localStorage.getItem("customerId")
                service.selJgProcesstaskP(JSON.parse(JSON.stringify(searchObj))).then(res => {
                    if (res.code == "200") {
                        if (res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        } else {
                            this.finished = true;
                        }
                        // 加载状态结束
                        this.loading = false;
                        this.isLoading = false;
                    } else {
                        this.loading = false;
                        this.finished = true;
                        this.isLoading = false;
                        Toast(res.msg)
                    }
                })
            },
            getTotalCount() {
                let createTimeStart = "";
                let createTimeEnd = "";
                let dateStr = this.searchValue
                if (dateStr != null && dateStr != "" && this.searchValue.startDate != "" && this.searchValue.endDate != "") {
                    createTimeStart = this.searchValue.startDate;
                    createTimeEnd = this.searchValue.endDate
                }

                let searchObj = this.searchValue
                searchObj.startDate = createTimeStart
                searchObj.endDate = createTimeEnd
                searchObj.page = null;
                searchObj.size = null;
                searchObj.ouid = localStorage.getItem("ouid")
                searchObj.customerId = localStorage.getItem("customerId")
                let _this = this;
                service.selJgProcesstaskSumData(searchObj).then(res => {
                    if (res.data != null) {
                        _this.sumWeight = res.data.sumWeight;
                        _this.taskCount = res.data.taskCount;
                        _this.notifyCount = res.data.notifyCount;
                    } else {
                        _this.sumWeight = '--';
                        _this.taskCount = '--';
                        _this.notifyCount = '--';
                    }
                })
            },
            searchPop() {
                this.show = true;
                this.searchShowPop = true;
            },
            onRefresh() {
                this.onLoad();
            },
            //日期组件
            formatDate(date) {
                return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            },
            calendarConfirm(date) {
                const [start, end] = date;
                this.calendarShow = false;
                this.showPickerSta = false
                this.searchValue.defaultDate = `${this.formatDate(start)} - ${this.formatDate(end)}`;
                this.searchValue.startDate = this.$moment(start).format("YYYY-MM-DD");
                this.searchValue.endDate = this.$moment(end).format("YYYY-MM-DD");
            },
            resetSearch() {
                this.searchValue = {};
                this.selProcessNotifyStatus = ""
                this.selProcessName = ""
                this.selMachineName = ""
                this.selMachineDetailName = ""
                this.selProcesstaskStatus = ""
                this.machineDetailData = []
                this.machineDetailCol = []
                this.status = ""
            },
            conventNotifyStatus(status) {
                if (status == 10) {
                    return "新建";
                } else if (status == 20) {
                    return "审核";
                } else if (status == 30) {
                    return "发料";
                } else if (status == 99) {
                    return "变更中";
                } else if (status == 100) {
                    return "完结";
                }
            },
            conventTaskStatus(status) {
                if (status == 10) {
                    return "新建";
                } else if (status == 20) {
                    return "待加工";
                } else if (status == 30) {
                    return "加工中";
                } else if (status == 40) {
                    return "已完成";
                } else if (status == 50) {
                    return "已验收";
                }
            },
            showDetail(flag, item) {
                this.detailPop = flag;
                if (flag) {
                    this.processtaskNo = item.processtaskNo
                    this.processtaskStatus = item.processtaskStatus
                    this.auditTime = item.auditTime
                    this.processnotifyCustomerNo = item.processnotifyCustomerNo
                    this.processName = item.processName
                    this.machineName = item.machineName
                    this.machineDetailName = item.machineDetailName
                    this.startTime = item.startTime
                    this.completeTime = item.completeTime

                    this.selRawMaterialListById(item)
                    this.selProductListByTaskId(item)
                }
            },
            selRawMaterialListById(item) {
                let param = {
                    processtaskId: item.processtaskId,
                }
                service.selRawMaterialListById(param).then(res => {
                    if (res.code == "200") {
                        if (res.data.length > 0) {
                            let proTotalCount = 0
                            let proTotalWeight = 0
                            res.data.map(it => {
                                proTotalCount += it.amount
                                proTotalWeight += it.weight
                            })
                            this.proTotalCount = proTotalCount
                            this.proTotalWeight = proTotalWeight
                            this.rawMaterialList = res.data
                        }
                    }
                })
            },
            selProductListByTaskId(item) {
                let param = {
                    processtaskId: item.processtaskId,
                }
                service.selProductListByTaskId(param).then(res => {
                    if (res.code == "200") {
                        if (res.data.length > 0) {
                            let pacCount = 0
                            let pacTotalCount = 0
                            let pacTotalWeight = 0
                            res.data.map(it => {
                                pacCount += 1
                                pacTotalCount += it.amount
                                pacTotalWeight += it.weight
                            })
                            let dataList = res.data
                            let mergeList = []
                            for (let i = 0; i < dataList.length; i++) {
                                if (dataList[i].processtaskPackageId) {
                                    if (mergeList.indexOf(dataList[i].processtaskPackageId) == -1) {
                                        mergeList.push(dataList[i].processtaskPackageId)
                                        dataList[i].isShowMerge = true;

                                        this.mergeList = mergeList
                                    } else {
                                        dataList[i].isShowMerge = false;
                                    }
                                } else {
                                    dataList[i].isShowMerge = false;
                                }

                                if (dataList[i].processtaskPackageId == null) {
                                    dataList[i].isShowView = true;
                                    dataList[i].showView = '';
                                } else {
                                    if (dataList[i + 1] != null) {
                                        if (dataList[i + 1].processtaskPackageId != dataList[i].processtaskPackageId) {
                                            dataList[i].isShowView = true;
                                            dataList[i].showView = '';
                                        } else {
                                            dataList[i].isShowView = false;
                                            dataList[i].showView = 'padding-bottom: 0';
                                        }
                                    } else {
                                        dataList[i].isShowView = true;
                                        dataList[i].showView = '';
                                    }
                                }
                            }
                            this.pacCount = pacCount
                            this.pacTotalCount = pacTotalCount
                            this.pacTotalWeight = pacTotalWeight
                            this.productList = dataList
                        }
                    }
                })
            },
            showPackageDetail(item) {
                let param = {processtaskId: item.processtaskId}

                if (item.processName == "打包") {
                    this.packageNo = [];
                    service.selPackageByTaskId(param).then(res => {
                        if (res.code == "200") {

                            let packageNo = [];
                            res.data.forEach(item => {
                                let str = item.packageNo;
                                packageNo.push(str)
                            });
                            packageNo = Array.from(new Set(packageNo));
                            packageNo.forEach(item => {
                                let child = []
                                res.data.forEach(p => {
                                    if (item == p.packageNo) {
                                        child.push(p)
                                    }
                                })
                                let one = child[0]
                                let title = one.packageNo + "（" + one.packageName + (one.packageNum > 1 ? "*" + one.packageNum : "") + "）"
                                this.packageNo.push({"packageNo": item, "title": title, "child": child})
                            });
                            this.packageList = res.data
                            this.packageDetailPop = true
                        }
                    })
                } else {
                    service.selProductByTaskId(param).then(res => {
                        if (res.code == "200") {
                            this.packageList = res.data
                            this.productDetailPop = true
                        }
                    })
                }

            },
            conventCargoName(item) {
                let str = "";
                str += item.cargoName + "/";
                str += item.cargoMaterialName + "/";
                if (item.fatThickness != undefined) {
                    str += item.fatThickness + "×";
                } else {
                    str += "×";
                }

                str += item.cargoWidth + "×";
                if (item.cargoLength == undefined || item.cargoLength == "" || item.cargoLength == "0") {
                    str += "C" + "/";
                } else {
                    if (item.cargoLength > 10000) {
                        str += item.cargoLength / 1000 + "m/";
                    } else {
                        str += item.cargoLength + "/";
                    }

                }

                str += item.cargoOriginName + "/";
                str += item.surfaceName + "";
                return str.replace("undefied", "");
            }
        }
    }
</script>

<style scoped>
    .van-popup {
        background-color: #f7f8fa;
    }

    .hejcss {
        background-color: #f7f8fa;
        font-size: 15px;
    }

    .searchwarp {
        margin-top: 46px;
    }

    .editwarp {
        width: 100%;
        margin: 56px auto;
    }

    .editwarp .swipewarp {
        margin-bottom: 10px;
    }

    .contentwarp {
        margin-top: 50px;
        height: calc(100vh - 50px) !important;
        /*height: 550px;*/
    }

    .detailHeader {
        background-color: #1989fa;
        height: 70px;
        text-align: center;
        padding-top: 20px;
        margin-bottom: 20px;
        color: white;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    .detailLabel {
        color: #727272;
    }

    .detailLabel.detailtitle {
        color: #323233;
        font-weight: bold;
    }

    /deep/ .van-nav-bar .van-icon,
    /deep/ .van-nav-bar__text,
    /deep/ .van-calendar__day--middle,
    .van-icon.van-icon-arrow {
        color: #6685a4;
    }

    /deep/ .van-button--info,
    /deep/ .van-button--danger {
        /*background-color: #6685a4 ;*/
        /*border: 1px solid #6685a4 ;*/
        background-color: white;
        border: 1px solid white;
        color: #6685a4;
    }

    /deep/ .van-button--warning {
        background-color: #6685a4;
        border: 1px solid #6685a4;
    }

    /deep/ .ewm .van-button--info {
        border: 1px solid #6685a4;
        width: 200px
    }


    .searchwarp[data-v-1405fac1] {
        margin-top: 56px;
    }

    /deep/ .van-calendar__day--start,
    /deep/ .van-calendar__day--end,
    /deep/ .detailHeader[data-v-1405fac1] {
        background-color: #6685a4;
    }

    /deep/ .van-calendar__day--middle {
        background-color: #e4ebf3;
    }

    /*.van-cell::after{
        border-bottom: none;
    }*/
    .van-icon.van-icon-arrow {
        vertical-align: middle;
        margin-left: 5px;
    }

    .van-grid {
        padding: 10px;
    }

    /deep/ .van-image__img {
        border: #e4ebf3 1px solid;
    }

    .closebutton {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0px;
        height: 50px;
        width: 100% !important;
        /*font-size: 12px;*/
        z-index: 9999;
    }

    .van-button--default {
        border: 1px solid #e2e2e2;
    }

    .van-divider {
        margin: 0px !important;
    }


    /deep/ .thmx > .van-row {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    /deep/ .van-cell__value.van-cell__value--alone > .thmx:last-child > .van-row {
        padding-top: 10px;
        padding-bottom: 0;
    }

    .button {
        font-size: 16px;
        color: #ffffff;
        background: #6685a4;
        height: 32px;
    }

    .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
    }

    .ellipsisRight {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: right;
    }
    .van-doc-demo-block__title {
        margin: 0;
        padding: 15px 16px 10px 16px;
        color: rgba(69, 90, 100, 1);
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        text-align: left;
    }
    /deep/ .van-cell__title{
        text-align: left;
        -webkit-box-flex: unset;
        -webkit-flex:unset;
        flex:unset;
        width: 90px;
        color: #969799;
    }
    /deep/ .van-cell__value{
        color: #323233;
    }
    .van-list .van-cell-group::after {
        border-bottom-width: 5px;
    }
    /deep/ .van-cell__title.van-field__label.van-field__label--right{
        text-align: right;
    }
</style>